import { Button, Dropdown } from 'antd'
import Flex from 'components/Flex'
import { StyledTabs } from 'components/TabsPaneStyles'
import styled from 'styled-components'
import { COLORS } from 'theme'
import { FONT } from 'theme/font'
export const DropDown = styled(Dropdown)``
export const DropBtn = styled(Button)`
  .ant-btn {
    background: ${COLORS.PRIMARY_GREY_T_98} !important;
  }
`
export const ThreeDotsDiv = styled.div`
  cursor: pointer;
  margin: 0 20px;
  .ant-btn {
    background: ${COLORS.PRIMARY_GREY_T_98} !important;
    border-radius: 10px !important;
    border: 1px solid ${COLORS.GREY_T_90} !important;
    box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
  }
`
export const StyledTab = styled(StyledTabs)`
  .ant-tabs-nav::before {
    border-bottom: none;
  }
  .ant-tabs-tab {
    border-bottom: none !important;
    padding: 15px 0 !important;
    background: transparent !important;
  }
  .ant-tabs-nav {
    width: 100% !important;
    margin: 0 !important;
  }
  .ant-tabs-tab-btn {
    color: ${COLORS.GREY_T_50_2};
    text-shadow: 0 0 0.25px currentcolor;
  }
  .ant-tabs-ink-bar {
    background: ${COLORS.PRIMARY} !important;
  }
  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: ${COLORS.PRIMARY};
  }

  width: 100%;
  .ant-tabs-content {
    height: ${props => (props?.height ? props.height : '250px')} !important;

    &::-webkit-scrollbar {
      display: none;
    }
  }
`
export const HeaderFlex = styled(Flex)`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const HeaderFlexATS = styled(Flex)`
  padding-bottom: 30px;
`

export const TopFlex = styled(Flex)`
  gap: 15px;
`

export const TopFlexNew = styled(Flex)`
  gap: 15px;
`
export const TopRightFlex = styled(Flex)``

export const TopRightFlexATS = styled(Flex)`
  gap: 20px;
`

export const ContactFlex = styled(Flex)``
export const NameDive = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_700};
  font-size: ${FONT.F_LG};
  line-height: 24px;
  color: ${COLORS.GREY_T_30};
  margin: 4px 0;
`
export const EmailIdDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_600};
  font-size: ${FONT.F_SM};
  line-height: 18px;
  color: ${COLORS.GREY_T_60};
  margin: 3px 0;
`
export const IconSpan = styled.span`
  margin-right: 10px;
`
export const RatingsDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_700};
  font-size: ${FONT.F_XS};
  line-height: 18px;
  color: ${COLORS.GREY_T_30};
  text-transform: capitalize;
`
export const RatingText = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_500};
  font-size: ${FONT.F_XS};
  line-height: 16px;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: ${COLORS.GREY_T_50_2};
`
export const TestDetailsFlex = styled(Flex)`
  padding: 0 10px 0 15px;
  border-right: 1px solid ${COLORS.GREY_T_90};
`
export const TestDetailsFlexNew = styled(Flex)`
  padding: 0 10px 0 15px;
  border-left: 1px solid ${COLORS.GREY_T_90};
`

export const TestDetailsFlex1 = styled(Flex)`
  padding: 0 10px 0 15px;
  border-left: 1px solid ${COLORS.GREY_T_90};
`
export const TestFlex = styled(Flex)`
  padding: 0 10px 0 15px;
`
export const StatusSpan = styled.span`
  margin-left: 10px;
  padding: 4px 6px;
  width: 77px;
  height: 23px;
  background: #eff8f4;
  border: 1px solid #bee1d4;
  border-radius: 6px;
  font-style: normal;
  font-weight: ${FONT.FW_700};
  font-size: ${FONT.F_XS};
  line-height: 15px;
  color: ${COLORS.GREEN_S_100};
`
export const YellowStartSpan = styled.span`
  margin-left: 8px;
`
export const StatusWrapper = styled.div`
  padding-left: 10px;
`

export const AIMatchWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-top: 16px;
`

export const ScoreBox = styled.div`
  border: 1px solid ${props => props.isRejected ? '#E35E50' : '#52c41a'};
  border-radius: 12px;
  padding: 10px 14px;
  text-align: center;
  min-width: 90px;
`

export const Score = styled.div`
  font-size: 24px;
  font-weight: 700;
`

export const ScoreLabel = styled.div`
  font-size: 12px;
  color: #666;
`

export const Stars = styled.div`
  color: #faad14;
  font-size: 12px;
  margin-top: 4px;
`

export const MatchContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`

export const MatchText = styled.div`
  font-size: 13px;
  color: #555;
  max-width: 480px;
`

export const CriteriaRow = styled.div`
  font-size: 14px;
  color: #000;
  display: flex;
  align-items: center;
  gap: 8px;
`

export const InfoIcon = styled.div`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #e6e6e6;
  font-size: 11px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`

export const ShortlistButtonGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 0;
  margin-left: auto;

  .ant-btn {
    border-radius: 0 !important;
  }

  .ant-btn:first-child {
    border-radius: 10px 0 0 10px !important;
  }

  .dropdown-arrow-btn {
    border-radius: 0 10px 10px 0 !important;
    border-left: none !important;
    padding: 0 10px !important;
    min-width: 36px !important;
  }
`

export const SplitButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;
  gap: 8px;

  .main-btn {
    border-radius: 10px 0 0 10px !important;
  }

  .arrow-btn {
    border-radius: 0 10px 10px 0 !important;
    border-left: none !important;
    padding: 0 10px !important;
    min-width: 36px !important;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`

export const InfoWrapper = styled.div`
  position: relative;
  display: inline-block;
`

export const TooltipBox = styled.div`
  position: absolute;
  top: 28px;
  left: -120px;

  width: 293px;
  padding: 10px;
  background: #ffffff;
  border-radius: 15px;

  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.12);
  z-index: 1000;
`

export const TooltipItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
  font-size: 13px;
`

export const GrayCheckbox = styled.div`
  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #DADADA;
    border-color: #DADADA;
  }
  .ant-checkbox-checked .ant-checkbox-inner::after {
    border-color: #fff;
  }
`